import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import { navigate } from "gatsby"

import { Label, ButtonWithLoader } from "../../../Shared"
import { availablePostcodes } from "../../../../constants"
import { quoteResultURL } from "../../../../utilities"

export const QuestionPostcode = ({ answers, currentQuestion }) => {
  const [postcode, setPostcode] = React.useState("")
  const [isSubmitting, setIsSubmitting] = React.useState(false)
  const [error, setError] = React.useState("")

  const submitForm = async (postcode) => {
    setIsSubmitting(true)

    if (postcode.length > 0) {
      const postcodeArea = postcode.substring(0, 2).toUpperCase()

      if (
        availablePostcodes.some((avPostcode) => avPostcode === postcodeArea)
      ) {
        const quote = { ...answers, postcode: postcode }

        try {
          const response = await axios({
            method: "post",
            url: `${process.env.GATSBY_API_BASE_URL}/quote/create`,
            data: { quote: quote },
          })

          localStorage.removeItem("orderId")
          localStorage.removeItem("orderNumber")
          localStorage.removeItem("quoteId")
          const quoteUrl = quoteResultURL(response.data.quoteId)
          localStorage.setItem("quoteId", response.data.quoteId)
          navigate(quoteUrl)
        } catch (error) {
          console.log(error.response)
        }
      } else {
        setError("Sorry, we don't install in your area")
      }
    } else {
      setError("Please enter your postcode")
    }

    setIsSubmitting(false)
  }

  return (
    <div
      className={`boiler-quote-question boiler-quote-postcode${
        currentQuestion ? " active" : ""
      }`}
    >
      <h1 className="heading-large">
        <span className="boiler-quote-question-marker"></span>
        What is your postcode?
      </h1>
      <p className="boiler-quote-question-tip">
        We need to check you live within our installation area
      </p>
      <section className="boiler-quote-answers">
        <div className="form-wrapper">
          <div className="boiler-quote-postcode-form">
            <div className={`input${error ? " form-error" : ""}`}>
              <Label name="postcode">Your postcode</Label>
              <input
                value={postcode}
                className="input-field"
                type="text"
                name="postcode"
                id="postcode"
                onChange={(e) => setPostcode(e.target.value)}
              />
              <span className="form-error-text">{error ? error : ""}</span>
            </div>
            <ButtonWithLoader
              onClick={() => submitForm(postcode)}
              disabled={isSubmitting}
            >
              Get your results
            </ButtonWithLoader>
          </div>
        </div>
      </section>
    </div>
  )
}

QuestionPostcode.propTypes = {
  answers: PropTypes.object.isRequired,
}
